const ArticleContents = () => {
  const contentsItems = [...document.querySelectorAll(".article-main__contents ul li")];

  if (contentsItems.length > 0) {
    contentsItems[0].classList.add("active");
    
    contentsItems.forEach((contentsItem) => {
      contentsItem.addEventListener("click", () => {
        contentsItems.forEach((item) => {
          item.classList.remove("active");
        });

        contentsItem.classList.add("active");
      })
    });
  }
}

export default ArticleContents;